import React from 'react'
import { Button, Col, Collapse, Switch, Row } from 'antd'
import { FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'

import { Input } from 'src/components/Formik'
import { Policy } from 'src/types'

import * as CSS from './styles'
import GeneralRules from './general-rules'
import ServiceRules from './service-rules'
import ServicesResources from './services-resources'
import ExpenseRules from './receipt-rules'

import { Empty } from '../utils'

interface PolicyRulesProps {
  formikProps: FormikProps<Policy>
  toggle: () => void
}
export function PolicyRules({
  formikProps,
  toggle
}: PolicyRulesProps): JSX.Element {
  const { t } = useTranslation()

  return (
    <>
      <CSS.TitleContent>
        <CSS.Title level={3}>{t('web.policies.rules.title-list')}</CSS.Title>
        <Button
          icon="plus"
          key="common.actions.add"
          onClick={toggle}
          size="large"
          type="primary"
        />
      </CSS.TitleContent>
      <Collapse accordion>
        {(formikProps.values?.policy_rules?.length &&
          formikProps.values?.policy_rules.map((item, index) => (
            <Collapse.Panel
              header={`${item.reason?.code && `${item.reason?.code} - `}${
                item.reason?.name
              }`}
              key={index}
              extra={
                <div
                  onClick={event => {
                    formikProps.setFieldValue(
                      `policy_rules[${index}].active`,
                      !item.active
                    )
                    event.stopPropagation()
                  }}
                >
                  <CSS.ReasonActive>
                    <Switch
                      checkedChildren={t('common.active')}
                      checked={item.active}
                      unCheckedChildren={t('common.inactive')}
                    />
                  </CSS.ReasonActive>
                </div>
              }
            >
              <Row gutter={24}>
                <Col offset={1} span={11}>
                  <Input
                    formikProps={formikProps}
                    label="web.policies.name"
                    name={`policy_rules.${index}.name`}
                    placeholder="web.policies.rules.description-placeholder"
                    required={false}
                  />
                </Col>
                <Col span={11}>
                  <Input
                    formikProps={formikProps}
                    label="web.policies.rules.description"
                    name={`policy_rules.${index}.description`}
                    placeholder="web.policies.rules.description-placeholder"
                    required={false}
                  />
                </Col>
              </Row>
              <ServicesResources
                formikProps={formikProps}
                policyRuleIndex={index}
              />
              <br />
              <GeneralRules formikProps={formikProps} policyRuleIndex={index} />
              <ServiceRules
                formikProps={formikProps}
                keyPrefix="air"
                policyRuleIndex={index}
              />
              <ServiceRules
                formikProps={formikProps}
                keyPrefix="hotel"
                policyRuleIndex={index}
              />
              <ServiceRules
                formikProps={formikProps}
                keyPrefix="vehicle"
                policyRuleIndex={index}
              />
              <ExpenseRules formikProps={formikProps} policyRuleIndex={index} />
            </Collapse.Panel>
          ))) || <Empty message={t('common.no-data-found')} />}
      </Collapse>
    </>
  )
}
